"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");

var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");

var DefaultAudioMixController = /*#__PURE__*/function () {
  function DefaultAudioMixController(logger) {
    _classCallCheck(this, DefaultAudioMixController);

    this.logger = logger;
    this.audioDevice = null;
    this.audioElement = null;
    this.audioStream = null;
    this.browserBehavior = new DefaultBrowserBehavior_1.default();
    this.observers = new Set();
  }

  _createClass(DefaultAudioMixController, [{
    key: "bindAudioElement",
    value: function bindAudioElement(element) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (element) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Cannot bind audio element: ".concat(element));

              case 2:
                this.audioElement = element;
                this.audioElement.autoplay = true;
                return _context.abrupt("return", this.bindAudioMix());

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "unbindAudioElement",
    value: function unbindAudioElement() {
      var _this = this;

      if (!this.audioElement) {
        return;
      }

      this.audioElement.srcObject = null;
      this.audioElement = null;
      this.forEachObserver(function (observer) {
        if (_this.audioStream) {
          observer.meetingAudioStreamBecameInactive(_this.audioStream);
        }
      });
    }
  }, {
    key: "bindAudioStream",
    value: function bindAudioStream(stream) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (stream) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.audioStream = stream;
                _context2.prev = 3;
                _context2.next = 6;
                return this.bindAudioMix();

              case 6:
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](3);

                /* istanbul ignore else */
                if (this.logger) {
                  this.logger.warn("Failed to bind audio stream: ".concat(_context2.t0));
                }

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 8]]);
      }));
    }
  }, {
    key: "bindAudioDevice",
    value: function bindAudioDevice(device) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(device && !this.browserBehavior.supportsSetSinkId())) {
                  _context3.next = 2;
                  break;
                }

                throw new Error('Cannot select audio output device. This browser does not support setSinkId.');

              case 2:
                // Always set device -- we might be setting it back to `null` to reselect
                // the default, and even in that case we need to call `bindAudioMix` in
                // order to update the sink ID to the empty string.
                this.audioDevice = device;
                return _context3.abrupt("return", this.bindAudioMix());

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(observerFunc) {
      var _iterator = _createForOfIteratorHelper(this.observers),
          _step;

      try {
        var _loop = function _loop() {
          var observer = _step.value;
          AsyncScheduler_1.default.nextTick(function () {
            observerFunc(observer);
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "bindAudioMix",
    value: function bindAudioMix() {
      var _a, _b;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var previousStream, shouldSetSinkId, newSinkId, oldSinkId, existingAudioElement, existingStream;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.audioElement) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                previousStream = this.audioElement.srcObject;

                if (this.audioStream) {
                  this.audioElement.srcObject = this.audioStream;
                }

                if (previousStream !== this.audioStream) {
                  this.forEachObserver(function (observer) {
                    if (previousStream) {
                      observer.meetingAudioStreamBecameInactive(previousStream);
                    }

                    if (_this2.audioStream) {
                      observer.meetingAudioStreamBecameActive(_this2.audioStream);
                    }
                  });
                } // In usual operation, the output device is undefined, and so is the element
                // sink ID. In this case, don't throw an error -- we're being called as a side
                // effect of just binding the audio element, not choosing an output device.


                shouldSetSinkId = ((_a = this.audioDevice) === null || _a === void 0 ? void 0 : _a.deviceId) !== this.audioElement.sinkId;

                if (!(shouldSetSinkId && typeof this.audioElement.sinkId === 'undefined')) {
                  _context4.next = 8;
                  break;
                }

                throw new Error('Cannot select audio output device. This browser does not support setSinkId.');

              case 8:
                newSinkId = this.audioDevice ? this.audioDevice.deviceId : '';
                oldSinkId = this.audioElement.sinkId;

                if (!(newSinkId === oldSinkId)) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt("return");

              case 12:
                // Take the existing stream and temporarily unbind it while we change
                // the sink ID.
                existingAudioElement = this.audioElement;
                existingStream = this.audioStream;

                if (this.browserBehavior.hasChromiumWebRTC()) {
                  existingAudioElement.srcObject = null;
                }

                if (!shouldSetSinkId) {
                  _context4.next = 25;
                  break;
                }

                _context4.prev = 16;
                _context4.next = 19;
                return existingAudioElement.setSinkId(newSinkId);

              case 19:
                _context4.next = 25;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4["catch"](16);
                (_b = this.logger) === null || _b === void 0 ? void 0 : _b.error("Failed to set sinkId for audio element: ".concat(_context4.t0));
                throw _context4.t0;

              case 25:
                if (this.browserBehavior.hasChromiumWebRTC()) {
                  existingAudioElement.srcObject = existingStream;
                }

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[16, 21]]);
      }));
    }
  }, {
    key: "getCurrentMeetingAudioStream",
    value: function getCurrentMeetingAudioStream() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.audioStream);

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "addAudioMixObserver",
    value: function addAudioMixObserver(observer) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.observers.add(observer);

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "removeAudioMixObserver",
    value: function removeAudioMixObserver(observer) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.observers.delete(observer);

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }]);

  return DefaultAudioMixController;
}();

exports.default = DefaultAudioMixController;